export const usmle1ImmunologyModule = {
  id: "immunology",
  title: "Immunology",
  sections: [
    {
      type: "text",
      content:
        "Type I hypersensitivity is IgE-mediated. Type II is antibody-mediated cytotoxicity.",
    },
    {
      type: "question",
      text: "Which hypersensitivity type is IgE-mediated?",
      options: ["Type I", "Type II", "Type III", "Type IV"],
      correct: 0,
      explanation: "Type I is immediate, IgE-mediated.",
    },
  ],
};
